import React, { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/public-notices/PublicNoticesAction";
import { redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../../_metronic/layout";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { PublicNoticeAddForm } from "./PublicNoticeAddForm";

export function PublicNoticeAdd({
  history
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, publicNotice } = useSelector(
    (state) => ({
      actionsLoading: state.publicNotices.actionsLoading,
      isSuccess: state.publicNotices.isSuccess,
      type: state.publicNotices.type,
      publicNotice: state.publicNotices.publicNotice
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getNewPublicNotice());
    return () => dispatch(actions.cleanPublicNoticesState());
  }, [dispatch]);
  
  useEffect(() => {
    let _title = "Genel Duyuru Ekle";
    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subheader]);

  /** Belli Bir Genel Duyuruyu (Okul Duyurusu) Kaydeder */
  const savePublicNotice = (formData) => {
    dispatch(actions.savePublicNotice(formData)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/genel-duyurular`), 2500);
  };

  const btnRef = useRef();  
  const savePublicNoticeClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <PublicNoticeAddForm
            publicNotice={publicNotice}
            btnRef={btnRef} 
            savePublicNotice={savePublicNotice}
          />
        </div>        
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={savePublicNoticeClick}
          >
            Gönder
          </button>
        </div>
      </CardFooter>
    </Card>
  );
}